var _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _line, _line2, _line3, _line4, _circle10, _circle11, _circle12;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCommunityIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 4,
    fill: "#F687B3"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 16,
    r: 6,
    fill: "#63B3ED"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 48,
    cy: 32,
    r: 6,
    fill: "#9F7AEA"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 48,
    r: 6,
    fill: "#63B3ED"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 32,
    r: 6,
    fill: "#9F7AEA"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 44,
    cy: 20,
    r: 5,
    fill: "#F687B3"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 44,
    cy: 44,
    r: 5,
    fill: "#F687B3"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 44,
    r: 5,
    fill: "#F687B3"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 5,
    fill: "#F687B3"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 32,
    y1: 16,
    x2: 32,
    y2: 48,
    stroke: "#9F7AEA",
    strokeWidth: 2,
    opacity: 0.6
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 16,
    y1: 32,
    x2: 48,
    y2: 32,
    stroke: "#9F7AEA",
    strokeWidth: 2,
    opacity: 0.6
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 20,
    y1: 20,
    x2: 44,
    y2: 44,
    stroke: "#9F7AEA",
    strokeWidth: 2,
    opacity: 0.6
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 44,
    y1: 20,
    x2: 20,
    y2: 44,
    stroke: "#9F7AEA",
    strokeWidth: 2,
    opacity: 0.6
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 6,
    stroke: "#63B3ED",
    strokeWidth: 1,
    opacity: 0.2
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 8,
    stroke: "#63B3ED",
    strokeWidth: 1,
    opacity: 0.15
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 10,
    stroke: "#63B3ED",
    strokeWidth: 1,
    opacity: 0.1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommunityIcon);
export default __webpack_public_path__ + "static/media/community-icon.efd6648cba41b4292c1b8d87b5e6c81e.svg";
export { ForwardRef as ReactComponent };